const ProjectHelper = class ProjectHelper {
    isQuoteOrOrderOrProduction(status) {
        return ['Quote', 'Order', 'ProductionOrder'].includes(status);
    }
}

export default new ProjectHelper()